export default {
  'page-title': 'Creative Return Merchandize Authorization (RMA) System - Creative Labs (Taiwan) ',
  'page-desc': 'Check the status of your return request with your RMA number. ',
  'mode-of-contact': '聯絡方式',
  'your-details': '個人資料',
  'rma-request': 'RMA請求',
  'first-name': '名字 (根據身分證)',
  'last-name': '姓氏 (根據身分證)',
  'enter-first-name': '請輸入您的名字。',
  'enter-last-name': '請輸入您的姓氏。',
  'email-address': '電子郵件地址',
  'enter-email': '請輸入您的電子郵件地址。',
  'enter-valid-email': '請輸入有效的電子郵件地址。',
  'enter-pid': '請輸入您的身分證號',
  'super-x-fi': '聲晰飛',
  'products': '產品',
  'sale': '促銷',
  'help': '幫助',
  'sign-in': '登入',
  'account': '帳號',
  'loading-page': '載入中',
  'orders': '訂單',
  'membership-program': '會員活動',
  'account-profile': '帳戶資料',
  'contact-us': '聯係我們',
  'sign-out': '登出',
  'recent-orders': '最近的訂單',
  'view-all-orders': '查看所有訂單',
  'email_registered': {
    'text1': '{email} 已被註冊，請',
    'link': '登入',
    'text2': ' 帳號查看您的訂單歷史記錄。'
  },
  'country-region': '國家/地區',
  'select-country': '請選擇國家。',
  'preferred-language': '首選回复語言',
  'select-language': '請選擇語言。',
  'next': '下一步',
  'encountered-error': '遇到錯誤。請再試一次。',
  'your-enquiry': '您的詢問',
  'nature-enquiry': '查詢類別',
  'order-number': '訂單號',
  'order-id': 'Amazon訂單編號',
  'for-amazon-order': '對於通過Amazon下的訂單',
  'enter-order-number': '請輸入您的訂單號。',
  'rma-number': 'RMA編號',
  'enter-rma-number': '請輸入您的RMA編號。',
  'purchase_creative_com': {
    'text': '如果您的產品是從Creative.com購買的 ',
    'link': '請從這裡申請換貨。'
  },
  'not-purchase-creative-com': '<p>如果您的產品不是直接從Creative.com購買的，請直接與零售商/代理商聯繫以要求退貨。</p><p><a href="https://tw.creative.com/help/warranty-returns" target="_blank">單擊此處了解更多保固以及退貨相關訊息。</a></p>',
  'not-purchase-creative-com-retailer-replacement': '如果您的產品不是直接從Creative.com購買的，請直接與零售商/代理商聯繫以要求換貨。<p><a href="https://tw.creative.com/help/warranty-returns" target="_blank">單擊此處了解更多保固以及退貨相關訊息。</a>',
  'not_purchase_creative_com_2': {
    'text': '如果您的產品不是直接從Creative.com購買的, ',
    'link': '請從這裡申請換貨。'
  },
  'order-not-found': '此訂單號不屬於該電子郵件地址。請再試一次。',
  'rma-not-found': '您輸入的RMA編號未在我們的記錄中找到。請輸入有效的RMA編號。',
  'previous-order': '上一個訂單',
  'next-order': '下一個訂單',
  'add-your-product': '添加您的產品',
  'search-by-name': '按產品名稱搜索',
  'select-product': '請選擇至少一種產品。',
  'upload-proof-update-date': {
    'text1': '請提供您的購買證明和購買日期。 <br/>如果您沒有購買證明，請從 ',
    'link': '這裏',
    'text2': ' 聯係我們'
  },
  'return-product': '退貨',
  'return-products': '退貨',
  'replace-defective-product': '更換有缺陷的產品',
  'check-rma-status': '查看RMA進展',
  'service-request': '服務請求',
  'select-one-service': '請選擇一個服務請求。如果同一個訂單有需要多個服務請求，請根據每個問題提交不同的服務請求。',
  'select-one-servcie-2': '請選擇一個服務請求。',
  'refund-products': '退貨退款',
  'qualifies-refund': '只有 {refundNotAvailable} 符合“滿意保證”條件，可以退款。<br />進行下一步之前，請先編輯您的產品。',
  'replace-products': '更換有缺陷的產品',
  'qualifies-replace': '只有 {repairNotAvailable} 符合更換條件。 <br />進行下一步之前，請先編輯您的產品。 ',
  'contact-us-assistance': '聯繫我們以獲得幫助',
  'return-information': '退貨信息',
  'replacement-information': '換貨信息',
  'fill-in-all': '請填寫本節中的所有内容。',
  'message': '訊息',
  'enter-message': '請輸入您的訊息。',
  'submit': '提交',
  'submission-successful': '您的請求已提交。',
  'contact-us-thank-you': '我們將在2個工作日內與您聯繫。',
  'back-to-home': '返回首頁',
  'confirmation': '確認',
  'rma-confirmation': 'RMA確認',
  'refresh-page': '刷新',
  'loading': '載入中...',
  'select': '選擇地址',
  'selected': '已選',
  'update': '編輯地址',
  'address': '地址',
  'new-address': '新地址',
  'edit': '編輯',
  'update-address': '更新地址',
  'cancel': '取消',
  'back': '返回',
  'select-your-products': '選擇您的產品',
  'serial-number': '序列號',
  'returns-eligibility': '退貨資格',
  'warranty': '保固期',
  'proof-purchase': '購買證明',
  'purchase-date': '購買日期',
  'select-date': '選擇日期',
  'how-find-serial-num': '如何查找序列號？',
  'yes': '有',
  'no': '無',
  'choose-file': '選擇文件',
  'remove': '刪除',
  'warranty-days-left': '還剩{warrantyDaysRemain} 天',
  'out-warranty': '保固期外',
  'enter-serial': '輸入序列號',
  'enter-serial-number': '請輸入有效的序列號。',
  'serial-not-valid': '序列號無效, 請輸入有效的序列號。',
  'serial-num-submitted': '序列號已提交, 請輸入有效的序列號。',
  'file-formats-allowed': '文件格式要求: JPG, PNG, ZIP。 文件大小上限: 4MB。',
  'thank-you-rma-submit': '感謝您提交RMA。 ',
  'provide-rma-number': '如果您就此RMA請求需要與我們聯繫，請向我們的客戶服務團隊提供您的RMA編號。',
  'retrieve_rma_status': {
    'text': '您也可以通過註冊以下內容來獲取RMA進展情況或對RMA進行更改 ',
    'link': 'Creative官網帳號'
  },
  'product-details': '產品詳情',
  'product': '產品',
  'rma-details': 'RMA詳情',
  'service-request2': '服務請求',
  'refund': '退款',
  'replacement': '換貨',
  'rma-status': 'RMA進展情況',
  'expires-date': '{date}到期',
  'refund-estimated-cost': '注意：退款金額目前只是估算值，可能會作進一步的更改。',
  'service-fee': '服務費',
  'service-fee-text': '如果您退回的產品出現意外損壞或濫用的跡象，則可能會收取額外服務費。 這種情況，我們將通過電子郵件與您聯繫。',
  'product-is-defective': '產品有問題',
  'repair-status-list': [
    {
      'status': 'RMA請求已收到',
      'desc': '<p>您的RMA請求當前正在處理中。<br /><i>(通常需要1-2個工作日)</i></p>'
    },
    {
      status: 'RMA請求已批准',
      desc: `<p>請把您的產品寄回給我們。 <br /><i>(通常需要1-2個工作日)</i></p>
              <span style="font-weight: 500;">換貨說明</span>
              <div class="return-instruction">
                有關产品退回說明，請參閱電子郵件（主題：您的Creative Labs換貨請求已獲批准）。
              </div>`

    },
    {
      status: '產品已簽收',
      desc: '<p>我們正在檢驗您退回的產品。<br /><i>(通常需要1-2個工作日)</i></p>',
    },
    {
      status: '替換產品準備中',
      desc: '<p>我們正在檢查您所換貨的產品的庫存情況。<br /><i>(通常需要1-2個工作日)</i></p>',
    },
    {
      status: '發貨準備中',
      desc: '<p>我們正在準備發貨您的替換產品。<br /><i>(通常需要1-2個工作日)</i></p>',
    },
    {
      status: '替換產品已發貨',
      desc: '<p>您的替換產品已發貨。  <br />  </p>',
    }
  ],
  'refund-status-list-backup-v1': [
    {
      'status': 'RMA請求已收到',
      'desc': '<p>您的RMA請求當前正在處理中。<br /><i>(通常需要1-2個工作日)</i></p>'
    },
    {
      status: 'RMA請求已批准',
      desc: `<p>請把您的產品寄回給我們。 <br /><i>(通常需要1-2個工作日)</i></p>
              <span style="font-weight: 500;">退貨說明</span>
              <div class="return-instruction">
                有關退貨說明，請參閱電子郵件（主題：您的Creative Labs退貨請求已獲批准）。

                <p style="margin:10px auto;{display}">您的運輸標籤必須在90天內完成下載。
                首次訪問該標籤後，必須在5天內下載或打印該標籤，此後將無法再使用此標籤。<br>
                <a href="{shippingLabelLink}" target="_blank" style="text-decoration:underline">運輸標籤</a></p>
              </div>`
    },
    {
      status: "產品已簽收",
      desc: "<p>我們正在檢驗您退回的產品。<br /><i>(通常需要1-2個工作日)</i></p>",
    },
    {
      status: "退款處理中",
      desc: "<p>您的產品已通過檢驗，我們正在處理您的退款請求。<span style='{showAmount}'> of <strong>{RefundAmtActual}</strong></span>.<br /><i>(通常需要3-5個工作日)</i></p>",
    },
    {
      status: "退款完成",
      desc: "<p>我們已通過您原來的付款方式完成退款。 您的銀行最多可能需要30天才能處理請求。 請與您的銀行聯繫以進行進一步的查詢。</p><p><i>(您的銀行可能最多需要30天的時間來處理退款事宜。)</i></p>",
    }
  ],
  'refund-status-list': [
    {
      'status': 'RMA請求已收到',
      'desc': '<p>您的RMA請求當前正在處理中。<br /><i>(通常需要1-2個工作日)</i></p>'
    },
    {
      status: 'RMA請求已批准',
      desc: `<p>請把您的產品寄回給我們。 <br /><i>(通常需要1-2個工作日)</i></p>
              <span style="font-weight: 500;">退貨說明</span>
              <div class="return-instruction">
                有關产品退回說明，請參閱電子郵件（主題：您的Creative Labs換貨請求已獲批准）。
              </div>`,

      desc2: `<p style="margin:10px auto;">請通過以下鏈接生成退貨標籤，然後輸入所需信息：<br>
              <br> <br>
              URL: <a href="{courierLabelLink}/" target="_blank">{courierLabelLink}/</a> <br>
              訂單號: {orderNumber} <span style='color:red'>Creative RMA No - need MIS to display</span> <br>
              退貨編碼:  {returnCode} <span style='color:red'>B2C tracking no - need MIS to display</span> <br>

              <br><br>

              首次訪問該標籤後，必須在5天內下載或打印該標籤，此後將無法再使用此標籤。<br>
              <a href="{shippingLabelLink}" target="_blank" style="text-decoration:underline">運輸標籤</a></p>`
    },
    {
      status: "產品已簽收",
      desc: "<p>我們正在檢測您退回的產品。<br /><i>(通常需要1-2個工作日)</i></p>",
    },
    {
      status: "退款處理中",
      desc: "<p>您的產品已通過檢測，我們正在處理您的退款請求。<span style='{showAmount}'> of <strong>{RefundAmtActual}</strong></span>.<br /><i>(通常需要3-5個工作日)</i></p>",
    },
    {
      status: "退款完成",
      desc: "<p>我們已通過您原來的付款方式完成退款。 您的銀行最多可能需要30天才能處理請求。 請與您的銀行聯繫以進行進一步的查詢。</p><p><i>(您的銀行可能最多需要30天的時間來處理退款事宜。)</i></p>",
    }
  ],
  'what-are-reason': '您退貨的原因是什麼？',
  'which-part-defective': '產品的哪一部分有問題？',
  'please-select-one': '請選擇一個',
  'cosmetic-damages': '產品是否有任何物理性/外觀上的損壞？',
  'attach-photo': '附上損壞照片:',
  'comments': '留言',
  'rma-exists': '已為此產品提交RMA請求。',
  'rma-created': '該產品已有RMA請求，無法再次創建。',
  'rma-cancelled': '您的RMA請求已被取消。如果您對RMA請求取消有任何疑問，請與我們聯繫。',
  'selected-maximum': '您已經選擇了最大數量。',
  'shipping-information': '物流訊息',
  'shipping-address': '收貨地址',
  'select-shipping-address': '請選擇收貨地址。',
  'replace-sent-address': '您的替換產品將發送到以下收貨地址。 ',
  'product-purchased-from': '產品購買于',
  'creative-store': 'Creative官方網站',
  'all-other-retailers': '所有其他零售商/代理商',
  'product-not-received': '未收到',
  'product-cancelled': '取消',
  'rma-closed': '關閉',
  'select-mode-of-contact': '請選擇您與我們聯繫的方式。',
  'email-us': '電郵我們',
  'your-order': '您的訂單',
  'refund-amount': '退款金額',
  'shipping-charge': '運費',
  'store-credit': '官網積分',
  'tax': '消费税',
  'pid': '身分證號',
  'deliver-unable-info':'',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `通知：為了更快、更好地為您服務，我們定於2022年10月09日（星期日）早上9時到下午3時（GMT +8:00）進行系統維護和升級。在此期間，您將無法訪問我們的網站。
                      <br><br>
                      給您帶來不便，敬請諒解！`,
  'shipping-country-notice-tw': ''
  }